import { swRequest } from "@sourcewhale/core";

export const queryCandidates = (body) =>
  swRequest({ path: "/api/candidates/query", method: "POST", body });

export const getDashboardToDos = ({ campaignType, userId }) =>
  swRequest({
    path: "/api/dashboard/todos",
    method: "POST",
    body: { campaignType, userId },
  });
